import React from 'react';

import Page from 'App/components/Page';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import AssessmentManagerSettingsForm from './AssessmentManagerSettingsForm';

const AssessmentManagerCreateSettings = () => {
    return (
        <Page permissionType={PERMISSION_TYPES.ASSESSMENT_MANAGER} title="New Assessment">
            <AssessmentManagerSettingsForm />
        </Page>
    );
};

export default AssessmentManagerCreateSettings;
